<template>
  <div>
    <Head title="Discounts" />
    <h1 class="mb-8 text-3xl font-bold">Discounts</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Deleted:</label>
        <select v-model="form.trashed" class="form-select mt-1 w-full">
          <option :value="null">Exclude Deleted</option>
          <option value="with">Include Deleted</option>
          <option value="only">Only Deleted</option>
        </select>
      </search-filter>
      <create-discount />
    </div>
    <div class="bg-white shadow overflow-x-auto overflow-y-hidden">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">Discount</th>
            <th class="pb-4 pt-6 px-6 text-center" colspan="2">Companies</th>
          </tr>
        </thead> <tbody>
          <tr v-for="discount in discounts.data" :key="discount.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <a class="flex items-center px-2 cursor-pointer" @click="discountToEdit = discount">
                {{ discount.value }}
                <icon v-if="discount.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-2 fill-gray-400" />
              </a>
            </td>
            <td class="border-t">
              <a class="flex items-center px-2 cursor-pointer justify-center" @click="discountToEdit = discount">
                <span class="rounded-full px-4 py-2 bg-gray-200">{{ discount.companies_count }}</span>
                <icon v-if="discount.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-2 fill-gray-400" />
              </a>
            </td>
            <td class="w-px border-t">
              <a class="px-2 cursor-pointer" @click="discountToEdit = discount">
                <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </a>
            </td>
          </tr>
          <tr v-if="discounts.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="4">No discounts found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="discounts.links" />

    <edit-discount v-if="discountToEdit" :discount="discountToEdit" @close="discountToEdit = null" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import CreateDiscount from './Create'
import EditDiscount from './Edit'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
    CreateDiscount,
    EditDiscount,
  },
  layout: Layout,
  props: {
    filters  : Object,
    discounts: Object,
  },
  data() {
    return {
      discountToEdit: null,
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/discounts', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
